import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';

export default el => {
    const dom = $(el);
    const list = dom.find('[data-list]');

    const update = () => {
        list.removeClass('-collapsed');
        if (list.width() > dom.width()) {
            list.addClass('-collapsed');
        }
    };

    const init = () => {
        Viewport.on('resize', update);
        update();
    };

    const destroy = () => {
        Viewport.off('resize');
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Breadcrumbs.js